import { render, staticRenderFns } from "./LoginHistoryView.vue?vue&type=template&id=22ec7fd8"
import script from "./LoginHistoryView.vue?vue&type=script&lang=js"
export * from "./LoginHistoryView.vue?vue&type=script&lang=js"
import style0 from "./LoginHistoryView.vue?vue&type=style&index=0&id=22ec7fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports